export const endpoints = {
	email: 'https://aw6xzoos9e.execute-api.eu-central-1.amazonaws.com/prod/email',
};

export const API_KEY = 'BNiHri7VIy4PyEXiBCxn46KLsdsik8h52PLILT8G';